/**
 * particular case, do not care about back-office answer
 */
export const SEPARATOR = 'separateur';

/**
 * class that represent one line of a whole finalAddress,
 */
export class AddressLine {

  /**
   * should we display a input for this value?
   */
  public bDataInput: boolean;

  /**
   * is the value optional or not
   */
  public bDataMandatory: boolean;

  /**
   * index of the field inside the associated formatted line
   */
  public iLineDataIndex: number;

  /**
   * inside of the line from the formatted finalAddress
   */
  public iLineNumber: number;

  /**
   * regex to validate for the adressLine
   */
  public sControlFmt: string;

  /**
   * max number of characters allowed in the input
   */
  public sDataLengthMax: number;

  /**
   * libele of the input field
   */
  public sDataLib: string;
  public sDataLibValue: string;

  /**
   * name of the data (useless)
   */
  public sDataName: string;

  /**
   * supposed to be the type of the input (string or number): not trustworthy
   */
  public sDataType: string;

  /**
   * if the element is the country
   */
  public sElemCountry: string;

  /**
   * useless number of element
   */
  public sElmtNumber: number;

  /**
   * value of the input field
   */
  public sDataValue;

  /**
   * constructor that'll instanciate using datas
   * @param {any} datas
   */
  constructor(datas: any) {
    this.bDataInput = datas.bDataInput;
    this.bDataMandatory = datas.bDataMandatory;
    this.iLineDataIndex = datas.iLineDataIndex;
    this.iLineNumber = datas.iLineNumber;
    this.sControlFmt = datas.sControlFmt;
    this.sDataLengthMax = datas.sDataLengthMax;
    this.sDataLib = datas.sDataLib;
    this.sDataName = datas.sDataName;
    this.sDataType = datas.sDataType;
    this.sElemCountry = datas.sElemCountry;
    this.sElmtNumber = datas.sElmtNumber;
     this.sDataLibValue = this.sDataLib;
    if (datas.sDataValue) {
      this.sDataValue = datas.sDataValue;
    }
    else {
      this.sDataValue = '';
    }

    // particular case, do not care about back-office answer
    if (datas.sDataLib === SEPARATOR) {
      this.bDataMandatory = true;
      this.bDataInput = true;
      this.sDataValue = ' ';
    }
  }

  /**
   * determine if the finalAddress line (and more precisely the input value) is valid
   * @return {boolean}
   */
  public isInputValid(): boolean {

    const respectRules = new RegExp(this.sControlFmt).test(this.sDataValue) && this.sDataValue.length <= this.sDataLengthMax;

    if (this.bDataMandatory) {
      if (this.sDataLib === SEPARATOR) {
        return respectRules;
      } else {
        return respectRules && this.sDataValue.trim() !== '';
      }
    } else {
      if (this.sDataValue.length > 0) {
        return respectRules;
      }
      else {
        return true;
      }
    }
  }
}
